import React, {Fragment, useEffect, useRef, useState} from 'react'
import {Button, Col, Form, Row} from 'react-bootstrap'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import {PageTitle} from '../../../../_metronic/layout/core'
import MasterServices from '../../../../services/master'
import CompanyServices from '../../../../services/company'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import Steps from 'rsuite/Steps'
import 'rsuite/dist/rsuite.min.css'

import Api from '../../../../thesis-and-dissertations/helpers/api'
import ReCAPTCHA from 'react-google-recaptcha'

const api = new Api()

const CreateCompany = () => {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null)
  const navigate = useNavigate()
  const [counter, setCounter] = useState(3)
  const [submit, setSubmit] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [formValue, setFormValue] = useState<any>({
    company_email: '',
    company_size_id: '',
    city_id: '',
    postal_code: '',
    company_name: '',
    company_address: '',
    company_website: '',
    company_year_founded: '',
    company_overview: '',
    document_mou: '',
    document_introduction_and_requirements: '',
    company_pic: '',
    company_pic_code_phone: '',
    company_pic_position: '',
    company_code_phone: '',
    company_phone: '',
    industries: '',
    languages: '',
    ownership_id: '',
  })
  const [
    ownerships,
    loadingOwnerships,
    emptyOwnerships,
    refreshOwnerships,
    isErrorOwnerships,
    setLoadingOwnerships,
  ] = useServices(
    MasterServices.getOwnership,
    {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
    []
  )
  const [
    countries,
    loadingCountries,
    emptyCountries,
    refreshCountries,
    isErrorCountries,
    setLoadingCountries,
  ] = useServices(
    MasterServices.getCountry,
    {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
    []
  )
  const [cities, loadingCities, emptyCities, refreshCities, isErrorCities, setLoadingCities] =
    useServices(
      MasterServices.getCity,
      {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
      []
    )
  const [
    industries,
    loadingIndustries,
    emptyIndustries,
    refreshIndustries,
    isErrorIndustries,
    setLoadingIndustries,
  ] = useServices(
    MasterServices.getIndustry,
    {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
    []
  )
  const [size, loadingSize, emptySize, refreshSize, isErrorSize, setLoadingSize] = useServices(
    MasterServices.getCompanySize,
    {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
    []
  )
  const [inputs, setInputs] = useState([
    {
      name: 'company_name',
      label: 'Nama Perusahaan*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'ownership_id',
      label: 'Kepemilikan*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'company_email',
      label: 'Email Perusahaan*',
      type: 'input',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'company_phone',
      label: 'No Telepon Perusahaan*',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'company_overview',
      label: 'Tentang Perusahaan*',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_address',
      label: 'Alamat Perusahaan*',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'country_id',
      label: 'Negara*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'countries_name',
      getItemValueId: 'countries_id',
    },
    {
      name: 'city_id',
      label: 'Kota/Kabupaten*',
      type: 'select2',
      validation: {},
      col: 6,
      options: cities || [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'company_website',
      label: 'Website (eg: https://lpdp.kemenkeu.go.id)',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_link_video_profile',
      label: 'Link Video Company Profil  (eg: https://lpdp.kemenkeu.go.id)',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_size_id',
      label: 'Jumlah Karyawan*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_sizes_name',
      getItemValueId: 'company_sizes_id',
    },
    {
      name: 'postal_code',
      label: 'Kode POS*',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_sizes_name',
      getItemValueId: 'company_sizes_id',
    },
    {
      name: 'industries',
      label: 'Tipe Industri*',
      type: 'select-creatable',
      validation: {},
      col: 6,
      items: [],
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'company_year_founded',
      label: 'Tahun Perusahaan Didirikan*',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },

    {
      name: 'company_pic',
      label: 'Nama PIC*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_phone',
      label: 'No Telpon PIC',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_email',
      label: 'PIC Email',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_position',
      label: 'Posisi PIC*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
  ])

  const [dataInfo, setDataInfo] = useState<any>([])

  useEffect(() => {
    let clone = inputs
    if (ownerships) {
      clone[1].options = ownerships?.data?.data
    }
    if (countries) {
      clone[6].options = countries?.data?.data
    }

    if (cities) {
      clone[7].options = cities?.data?.data
    }

    if (size) {
      clone[10].options = size?.data?.data
    }

    if (industries) {
      clone[12].options = industries?.data?.data
    }

    setInputs(clone)
    setCounter((val) => val + 1)
  }, [cities, countries, industries, ownerships, size])

  useEffect(() => {
    const storedData = localStorage.getItem('dataInfoFileMitra')
    if (storedData && storedData !== 'undefined') {
      setDataInfo(JSON.parse(storedData))
    } else {
      getTemplateFile()
    }
  }, [])

  const getTemplateFile = () => {
    api
      .getTemplateMitra('pernyataan_mitra_penyaluran')
      .then((response: any) => {
        const {data} = response
        setDataInfo(data)
        localStorage.setItem('dataInfoFileMitra', JSON.stringify(data))
      })
      .catch((error: any) => {
        const {data, status} = error.response
      })
  }

  const handleChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input
    switch (name) {
      case 'industries':
        getIndustries(row)
        break
    }
  }

  const getIndustries = async (q = '') => {
    try {
      const {data} = await MasterServices.getIndustry({...{is_active: 1}, q})
      let clone = inputs
      clone[13].items = data.data
      clone[13].options = data.data
      setInputs(clone)
    } catch (error) {
    }
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    setSubmit(true)

    const formData = new FormData(e.target)
    let formProps: any = Object.fromEntries(formData)

    try {
      await CompanyServices.registerCompany({
        ...formValue,
        ownership_id: formValue?.ownership_id?.company_ownerships_id ?? '',
        country_id: formValue?.country_id?.countries_id ?? '',
        city_id: formValue?.city_id?.cities_id ?? '',
        industries: formValue?.industries?.value ?? '',
        company_size_id: formValue?.company_size_id?.company_sizes_id ?? '',
        company_code_phone: '62',
        company_pic_code_phone: formValue?.company_pic_phone ? '62' : '',
        document_mou: formProps?.document_mou,
        document_introduction_and_requirements: formProps?.document_introduction_and_requirements,
      })

      setCurrentStep(3)
    } catch (error) {
      toast.error('Captcha invalid, silakan ulangi.')

      recaptchaRef.current?.reset()
      setFormValue((prev: any) => ({...prev, g_recaptcha_response: ''}))
    }

    setSubmit(false)
  }

  const handleChangeCaptcha = (value: any) => {
    setFormValue({...formValue, ['g_recaptcha_response']: value})
  }
  return (
    <Fragment>
      <Row className='p-8'>
        <Col md={3}>
          <div className='card-custom'>
            <img src={require('../../../../assets/img/logo-lpdp.png')} alt='' />
            <div className='mt-8'>
              <Steps current={5} vertical>
                <Steps.Item
                  title={<span style={{marginLeft: '20px'}}>Syarat & Ketentuan</span>}
                  // description={
                  //   <span style={{marginLeft: '20px'}}>Aturan penggunaan TallentHub</span>
                  // }
                  icon={
                    <Button
                      color='primary'
                      variant='outline'
                      className='btn-sm'
                      style={{
                        background: '#FF6C06',
                        borderRadius: '10px',
                        marginTop: '10px',
                      }}
                    >
                      1
                    </Button>
                  }
                />
                <Steps.Item
                  title={<span style={{marginLeft: '20px'}}>Informasi Perusahaan</span>}
                  // description={<span style={{marginLeft: '20px'}}>Data Perusahaan</span>}
                  icon={
                    <Button
                      color='primary'
                      variant='outline'
                      className='btn-sm'
                      style={
                        currentStep >= 2
                          ? {
                              background: '#FF6C06',
                              borderRadius: '10px',
                              marginTop: '10px',
                            }
                          : {
                              background: 'rgba(226, 226, 226, 0.25)',
                              border: '1px dashed #FF6C06',
                              marginTop: '10px',
                            }
                      }
                    >
                      2
                    </Button>
                  }
                />
                <Steps.Item
                  title={<span style={{marginLeft: '20px'}}>Selesai</span>}
                  // description={<span style={{marginLeft: '20px'}}></span>}
                  icon={
                    <Button
                      color='primary'
                      variant='outline'
                      className='btn-sm'
                      style={
                        currentStep >= 3
                          ? {
                              background: '#FF6C06',
                              borderRadius: '10px',
                              marginTop: '10px',
                            }
                          : {
                              background: 'rgba(226, 226, 226, 0.25)',
                              border: '1px dashed #FF6C06',
                              marginTop: '10px',
                            }
                      }
                    >
                      3
                    </Button>
                  }
                />
              </Steps>
            </div>
          </div>
        </Col>
        <Col md={9}>
          <div className='mb-8'>
            {currentStep === 1 && <h4>Syarat & Ketentuan Layanan</h4>}
            {currentStep === 2 && <h4>Informasi Perusahaan</h4>}
            {currentStep === 3 && <h4>Selesai</h4>}
            <p style={{maxWidth: '60%'}}>Syarat & Ketentuan Layanan Penggunaan Aplikasi</p>
          </div>
          <div>
            <div style={{display: currentStep === 1 ? '' : 'none'}}>
              <Fragment>
                <div
                  className='card-custom'
                  style={{
                    maxHeight: '600px',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    textAlign: 'justify',
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `
                  <p><strong>Syarat & Ketentuan Mitra Penyaluran Alumni LPDP</strong></p>
                  <p>
                    <span>
                      Halaman ini menyatakan ketentuan penggunaan (&ldquo;Ketentuan&rdquo;) di mana Anda (&ldquo;Anda&rdquo;) 
                      sebagai perwakilan dari (&ldquo;Mitra Perusahaan&rdquo;) dan hubungan Anda dengan Lembaga Pengelola Dana Pendidikan 
                      (LPDP atau &ldquo;kami&rdquo;) dalam menggunakan Situs Talent Hub. 
                      Mohon agar Syarat dan Ketentuan ini di baca dengan saksama karena akan mempengaruhi hak dan kewajiban Anda berdasarkan hukum. 
                      Jika Anda tidak setuju dengan persyaratan ini, harap jangan mendaftar atau menggunakan situs web Talent Hub. 
                      Ketentuan ini berlaku mulai 1 Juli 2023. Jika Anda memiliki pertanyaan tentang Ketentuan, silakan hubungi kami di sini 
                      <i><b>alumni.lpdp@kemenkeu.go.id</b></i>.
                    </span>
                  </p>
                  
                  <br>
                  
                  <p><span>1. Syarat dan ketentuan ini (&ldquo;<strong>Ketentuan</strong>&rdquo;) (mengatur semua Proses Pemasangan Lowongan Kerja (didefinisikan sebagai <strong>&ldquo;Mitra Perusahaan&rdquo;</strong> yang:</span></p>
                  
                  <ol style="margin-bottom:0cm;margin-top:0cm;" start="1" type="a">
                      <li>Menyetujui dan menandatangani Surat Pernyataan Mitra Kerja Sama Penyaluran Alumni LPDP sebagai syarat penggunaan Sistem Talent Hub</li>
                      <li>Memberikan informasi yang benar dan dapat dipertanggung jawabkan agar pengguna situs Talent Hub terhindar dari hal-hal yang merugikan</li>
                      <li>Pemberi Kerja wajib menginformasikan identitas asli perusahaannya dengan sebenar-benarnya untuk kepentingan pendaftaran akun dan penayangan lowongan pekerjaan oleh Talent Hub LPDP. Segala bentuk penipuan ataupun pencatutan identitas perusahaan sebagai pengguna akan ditindaklanjuti oleh Talent Hub LPDP</li>
                      <li>Bersedia memasukkan data perusahaan ke dalam Sistem Talent Hub</li>
                      <li>Bersedia untuk memasang lowongan pekerjaan di Sistem Talent Hub</li>
                      <li>Bersedia untuk mengakses Pusat Pengiklanan melalui Sistem Talent Hub (disebut sebagai Situs)</li>
                      <li>Bersedia menggunakan fitur-fitur Situs Talent Hub</li>
                  </ol>
                  
                  <br>
                  <p><span>2. Terdapat pilihan dalam Talent hub untuk menggunakan fitur - fitur &nbsp;berikut:&nbsp;</span></p>
                  <ol style="margin-bottom:0cm;margin-top:0cm;" start="1" type="a">
                    <li>Pengisian data perusahaan meliputi Nama Perusahaan, Jenis Kepemilikan, Email, No. Telpon, Tentang Perusahaan Alamat Perusahaan, Negara, Kota/Kabupaten*, Website, Video Company Profile*, Jumlah Karyawan, Tipe Industri, Nama, Email, dan No Telpon PIC Mitra Perusahaan</li>
                    <li>Pemasangan Iklan Lowongan Kerja</li>
                    <li>Pencarian Kandidat Pilihan</li>
                    <li>Pemrosesan lebih lanjut atas Kandidat yang terpilih</li>
                    <li>Penolakan bagi Kandidat yang tidak terpilih </li>
                    <li>Akses dan Pengunduhan data pelamar</li>
                    <li>Akses dan Pencarian data alumni LPDP</li>
                    <li>Pelaporan nama dan jumlah Kandidat yang diterima di Mitra Perusahaan</li>
                  </ol>
                  
                  <br>
                  <p><span>3. Situs dimiliki dan dioperasikan oleh LPDP. Penggunaan berkelanjutan oleh Anda atas Situs ini akan dianggap sebagai penerimaan Ketentuan ini oleh Anda</p>
                  
                  <br>
                  <p><span>4. Penggunaan Situs Talent Hub ini dibebaskan dari biaya apapun baik di masa sekarang dan yang akan datang.&nbsp;</span></p>
                  
                  <br>
                  <p><span>5. Pihak LPDP tidak diperbolehkan menerima biaya apapun dalam pelaksanaan pengelolaan Talent Hub ini dari Mitra Perusahaan khususnya pada proses pencarian dan pemilihan kandidat.&nbsp;</span></p>
                  
                  <br>
                  <p><strong>PERUBAHAN KETENTUAN&nbsp;</strong></p>
                  <p></p>
                  <ol style="margin-bottom:0cm;margin-top:0cm;" start="1" type="1">
                      <li>Kami dapat mengubah Ketentuan ini sewaktu-waktu. Kami akan memberikan pemberitahuan dengan memublikasikan Ketentuan yang diubah di Situs dan Anda menerima bahwa publikasi tersebut adalah pemberitahuan yang cukup</li>
                      <li>Anda akan diberitahukan mengenai setiap perubahan terhadap Ketentuan yang sewajarnya kami yakini akan merugikan Anda (Perubahan Yang Merugikan) 30 hari sebelum perubahan tersebut mulai berlaku (Jangka Waktu Pemberitahuan)</li>
                      <li>Dalam hal terdapat suatu Perubahan Yang Merugikan yang diusulkan, Anda dapat memilih untuk mengakhiri perjanjian Anda dengan kami selama Jangka Waktu Pemberitahuan dengan memberikan pemberitahuan tertulis paling lambat 5 hari sebelumnya</li>
                  </ol>

                  <br>
                  <p><strong>LARANGAN&nbsp;</strong></p>
                  <p></p>
                  <ol style="margin-bottom:0cm;margin-top:0cm;" start="1" type="1">
                      <li>Anda tidak boleh menggunakan alat penambangan data (<em>data mining</em>), robot, pengambilan data secara visual dari tampilan digital (<em>screen scraping</em>), atau alat pengumpulan, ekstraksi atau publikasi data otomatis yang serupa di Situs ini (termasuk tanpa batasan untuk keperluan menetapkan, mempertahankan, mengajukan atau mereproduksi informasi yang terdapat di Situs kami di suatu situs web lain atau dalam suatu publikasi lain), tanpa persetujuan tertulis kami terlebih dahulu</li>
                      <li>Tidak diperkenankan untuk menayangkan materi iklan yang mengandung unsur pornografi, agama, ras, suku, atau hal lain yang dapat menebar kebencian sosial.</li>
                      <li>Anda tidak boleh menggunakan Situs untuk memasang skema piramida atau skema pemasaran berjenjang (MLM) (bagaimanapun dijelaskan) di Situs</li>
                      <li>Anda tidak boleh meminta atau mewajibkan kandidat mana pun untuk membayar suatu biaya, pengeluaran, ongkos atau uang apapun juga sehubungan dengan proses perekrutan untuk suatu lowongan kerja yang diiklankan di Situs (termasuk untuk melamar) baik biaya, pengeluaran, ongkos atau uang tersebut diminta atau diwajibkan dari kandidat dalam iklan lowongan kerja itu sendiri atau dalam suatu komunikasi dengan kandidat yang terjadi sebagai hasil dari iklan lowongan kerja yang dipasang di Situs</li>
                      <li>Anda tidak boleh menggunakan fitur apa pun dari Situs untuk mengirimkan pesan elektronik komersial apa pun yang tidak diminta kepada para kandidat, baik secara individu atau sebagai suatu kelompok. Alat manajemen kandidat hanya dapat digunakan untuk berkomunikasi dengan para kandidat sesuai dengan Ketentuan Produk</li>
                      <li>Saluran komunikasi penyebaran informasi lowongan pekerjaan hanya akan dilakukan Anda dilarang merilis kepada publik, siaran berita, materi iklan, materi promosi atau bentuk publisitas lain apapun terkait dengan kami tanpa persetujuan tertulis kami terlebih dahulu</li>
                  </ol>
                `,
                    }}
                  />
                </div>
                <div className='mt-8' style={{float: 'right'}}>
                  <Button
                    variant='secondary'
                    type='button'
                    disabled={submit}
                    onClick={() => navigate('/auth')}
                    // onClick={() => setCurrentStep(1)}
                  >
                    Batal
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button onClick={() => setCurrentStep((val) => val + 1)}>Selanjutnya</Button>
                </div>
              </Fragment>
            </div>
          </div>
          <div style={{display: currentStep === 2 ? '' : 'none'}}>
            <Form onSubmit={handleSubmit}>
              <div className='card-custom'>
                <Row className='mb-8'>
                  {counter && FormGenerator(inputs, formValue, handleChange, onSelect, submit)}

                  <Col md={12} className='d-grid gap-4'>
                    <Row className='d-grid gap-4'>
                      <Col md={12}>
                        <Form.Label>
                          Unggah Surat Pernyataan
                          <a href={`${dataInfo?.url}`} target='_blank'>
                            (Template Surat Pernyataan)
                          </a>
                          *
                        </Form.Label>
                      </Col>
                      <Col md={12}>
                        <input
                          type='file'
                          name='document_mou'
                          // disabled={disabled} onChange={onChange}
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Text>pdf Max file size is 2MB</Form.Text>
                      </Col>
                    </Row>
                    <Row className='d-grid gap-4'>
                      <Col md={12}>
                        <Form.Label>
                          Unggah Surat Permohonan Kerja Sama Rekrutmen yang berisi Persyaratan
                          Lowongan Pekerjaan yang dibuka*
                        </Form.Label>
                      </Col>
                      <Col md={12}>
                        <input
                          type='file'
                          name='document_introduction_and_requirements'
                          // disabled={disabled} onChange={onChange}
                        />
                      </Col>
                      <Col md={12}>
                        <Form.Text>pdf Max file size is 2MB</Form.Text>
                      </Col>
                    </Row>

                    {/* ReCAPTCHA */}
                    <Row className='d-grid gap-4'>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        className='g-recaptcha'
                        sitekey="6Lf3qh8qAAAAAAmCYQOBXog8koATjbM4w7HZBGo2"
                        onChange={handleChangeCaptcha}
                      />
                      {/* {formik.touched.g_recaptcha_response &&
                        formik.errors.g_recaptcha_response && (
                          <div className='text-danger small mt-1'>
                            {formik.errors.g_recaptcha_response}
                          </div>
                        )} */}
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className='mt-8' style={{float: 'right'}}>
                <Button
                  variant='secondary'
                  type='button'
                  disabled={submit}
                  onClick={() => navigate('/auth')}
                  // onClick={() => setCurrentStep(1)}
                >
                  Batal
                </Button>
                &nbsp;&nbsp;&nbsp;
                <Button className='ml-6' type='submit' disabled={submit}>
                  Daftar
                </Button>
              </div>
              <br />
              <br />
              <br />
              <br />
            </Form>
          </div>
          <Fragment>
            <div className='card-custom' style={{display: currentStep === 3 ? '' : 'none'}}>
              <div className='p-8'>
                <img
                  src={require('../../../../assets/img/logo-lpdp.png')}
                  alt=''
                  style={{marginLeft: '40%'}}
                />
              </div>
              <p style={{marginLeft: '30%'}}>
                Pendaftaran akun perusahaan anda telah selesai. Silakan tunggu konfirmasi melalui
                email.
              </p>
              <Button
                style={{marginLeft: '40%'}}
                className='mt-8'
                onClick={() => navigate('/auth')}
              >
                Kembali Ke Halaman Login
              </Button>
              <br />
              <img
                src={require('../../../../assets/img/ok.png')}
                alt=''
                style={{marginLeft: '40%'}}
              />
            </div>
          </Fragment>
        </Col>
      </Row>
    </Fragment>
  )
}

export default CreateCompany
